import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./StickyNavbar.css"; // Ensure this file exists and contains the necessary styles
import stickylogo from "./assets/logo.gif"; // Corrected import path

const StickyNavbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [isMobile, setIsMobile] = useState(false); // Track if the screen is in mobile mode
    const navbarRef = useRef(null); // Ref for the sticky navbar

    // Handle scroll to make navbar sticky
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 180) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Check if the screen is in mobile mode
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true); // Hide StickyNavbar in mobile mode
            } else {
                setIsMobile(false); // Show StickyNavbar in desktop mode
            }
        };
        // Add event listener for window resize
        window.addEventListener("resize", handleResize);
        // Call handleResize initially to set the correct state
        handleResize();
        // Cleanup event listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // Close navbar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                setShowMenu(false); // Close the navbar
            }
        };
        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);
        // Cleanup event listener
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Hide StickyNavbar in mobile mode
    if (isMobile) {
        return null; // Return null to hide the StickyNavbar
    }
    return (
        <div className={`sticky-navbar ${isSticky ? 'is-sticky' : ''}`} ref={navbarRef}>
            <div className="logo">
                <NavLink to="/">
                    <img src={stickylogo} alt="Logo" className="logo-image" />
                    <p><b>Saad Motors </b> <br /> VEHICLE EXPORTING COMPANY</p>
                </NavLink>
            </div>

            {/* Toggle Button */}
            <div className="toggle">
                <button className="toggle-button" onClick={() => setShowMenu(!showMenu)}>
                    ☰
                </button>
            </div>

            <ul className={`nav-items ${showMenu ? "show" : ""}`}>
                <li className="dropdown">
                    <NavLink to="/" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                        Home
                    </NavLink>
                </li>
                <li className="dropdown">
                    <NavLink to="/search-cars" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                        Search Car
                    </NavLink>
                </li>
                <li className="dropdown">
                    <NavLink to="/banking-details" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                        Banking Details
                    </NavLink>
                </li>
                <li className="dropdown">
                    <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                        Services
                    </NavLink>
                    <ul className="dropdown-menu">
                        <li><NavLink to="/chassis-check">Chassis Check</NavLink></li>
                        <li><NavLink to="/shipping">Shipping Schedule</NavLink></li> 
                    </ul>
                </li>
                <li className="dropdown">
                    <NavLink to="#" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
                        About Us
                    </NavLink>
                    <ul className="dropdown-menu">
                        <li><NavLink to="/company-profile">Company Profile</NavLink></li>
                        <li><NavLink to="/how-to-buy">How To Buy</NavLink></li>
                        <li><NavLink to="#">Customer Reviews</NavLink></li>
                        <li><NavLink to="/terms-condition">Terms/Condition</NavLink></li>
                        <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                        <li><NavLink to="/faq-page">FAQ</NavLink></li>
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default StickyNavbar;